// src/components/common/WidgetWrapper.tsx

import { ReactNode } from 'react';
import { Card, CardContent, Grid, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Skeleton from '@material-ui/lab/Skeleton';

type WidgetWrapperProps = {
  title: string;
  loading: boolean;
  error?: string | null;
  children?: ReactNode;
};

export const WidgetWrapper = ({
  title,
  loading,
  error,
  children,
}: WidgetWrapperProps) => {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6">{title}</Typography>

        {loading && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Skeleton variant="rect" width="100%" height={120} />
            </Grid>
          </Grid>
        )}

        {!loading && error && <Alert severity="error">Error: {error}</Alert>}

        {!loading && !error && children}
      </CardContent>
    </Card>
  );
};
